module.exports = __webpack_public_path__ + "img/logo_ch.e068dfa3.png";